var Helpers;
(function (Helpers) {
    myonce('helpers', () => {
        const $helpers = document.querySelectorAll('[data-helper]');
        $helpers.forEach(($helper) => {
            const actions = $helper.getAttributeNames();
            $helper.addEventListener('click', (e) => {
                actions.forEach((action) => {
                    let targets, $target, flag, props;
                    props = $helper.getAttribute(action).split(':');
                    targets = props[0].split(',');
                    switch (action) {
                        case 'data-toggle':
                            flag = props[1] || 'is-active';
                            targets.forEach((target) => {
                                $target = target && document.querySelector(target) || $helper;
                                $target.classList.toggle(flag);
                            });
                            break;
                        case 'data-close':
                        case 'data-remove':
                            flag = props[1] || 'is-active';
                            targets.forEach((target) => {
                                $target = target && document.querySelector(target) || $helper;
                                $target.classList.remove(flag);
                            });
                            break;
                        case 'data-open':
                        case 'data-add':
                            flag = props[1] || 'is-active';
                            targets.forEach((target) => {
                                $target = target && document.querySelector(target) || $helper;
                                $target.classList.add(flag);
                            });
                            break;
                        case 'data-scroll-toggle':
                            flag = props[1] || 'scrollLock';
                            targets.forEach((target) => {
                                $target = target && document.querySelector(target);
                                if ($target) {
                                    $target.classList.toggle(flag);
                                }
                            });
                            break;
                        case 'data-scroll-lock':
                            flag = props[1] || 'scrollLock';
                            targets.forEach((target) => {
                                $target = target && document.querySelector(target);
                                if ($target) {
                                    $target.classList.add(flag);
                                }
                            });
                            break;
                        case 'data-scroll-release':
                            flag = props[1] || 'scrollLock';
                            targets.forEach((target) => {
                                $target = target && document.querySelector(target);
                                if ($target) {
                                    $target.classList.remove(flag);
                                }
                            });
                            break;
                        case 'data-scroll-to':
                            flag = props[1] || 0;
                            targets.forEach((target) => {
                                $target = target && document.querySelector(target);
                                if ($target) {
                                    scrollTo($target, flag, 500);
                                }
                            });
                            break;
                        case 'data-checked':
                            flag = props[1] || true;
                            targets.forEach((target) => {
                                $target = target && document.querySelector(target);
                                if ($target) {
                                    $target.checked = flag;
                                }
                            });
                            break;
                        case 'data-hidden':
                            flag = props[1] || 'd-none';
                            targets.forEach((target) => {
                                $target = target && document.querySelector(target) || $helper;
                                $target.classList.add(flag);
                            });
                            break;
                        case 'data-show':
                            flag = props[1] || 'd-none';
                            targets.forEach((target) => {
                                $target = target && document.querySelector(target) || $helper;
                                $target.classList.remove(flag);
                            });
                            break;
                    }
                });
            });
        });
    });
})(Helpers || (Helpers = {}));
